// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.svg_viewbox {
  float : left;
  width: 150%;
  height : 125%;
  padding: 2x;
  border-radius: 10px;
  stroke : #395e65;
}

.svg_viewbox_fullscreen {
  padding: 2x;
  stroke : #395e65;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
}
.qual_precision {
  font-family : Helvetica;
  accent-color : #becdbe; 
  font-size : small;
  color : #becdbe;
  stroke-width : 50px;
} 

.range_input{
  cursor : crosshair;
  appearance : false;
  height : 4px;
}

.depthlist_option {
  /* flex: 0 20 40px; /* Ajuster la largeur des options */
  transition: transform 0.3s, opacity 0.3s;
  height : 19px;
  border-radius: 2px;
  padding : 3px;
  min-width : 100px;
  text-align: center;
  border: 8px solid #395e65;
  background-color: #becdbe;
  cursor: pointer;
  transform : scaley(0.7);
  margin : 5px;
  font-size: x-small;
  box-shadow: 0 0 10px #395e65;
  transition: box-shadow 0.5s ease-in-out;
}


.depthlist_option.active {
  color: #395e65;
  background-color: #fff066;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.8);
  z-index: 1;
}

.createConvForm{
  cursor : pointer;
  display : flex;  
  flex-direction: column;
  gap : 1rem;
  font-family : Helvetica;
  stroke : #010506;
  fill : #395e65; 
  font-size : 4.5px;
  stroke-width : 0.24;
  padding: 5px;
  margin : 5px;
  z-index : 20;
}

.correctionForm{
  cursor : pointer;
  display : flex;  
  flex-direction: column;
  gap : 1rem;
  font-family : Helvetica;
  stroke : #010506;
  fill : #395e65; 
  font-size : 10px;
  stroke-width : 0.24;
  padding: 5px;
  margin : 5px;
  z-index : 10;
}
  .svg_dom_message{
    cursor : pointer;
    font-family : Helvetica;
    stroke : #010506;
    fill : #395e65; 
    font-size : 4.5px;
    stroke-width : 0.24;
  }

  .svg_dom_message.concept{
    cursor : url("https://altai-ego.com:3050/images/eye.svg") 8 8, auto;
    font-family : Helvetica;
    stroke : #010506;
    fill : #395e65; 
    font-size : 4.5px;
    stroke-width : 0.24;
    border: 1px solid #010506;
  }

.tab_svg_dom_message{
  font-family : Helvetica;
  stroke : #010506;
  fill : #395e65; 
  font-size : 4.5px;
  stroke-width : 0.6;
  font-weight: bold;
  text-anchor : middle;
}

.svg_node_label_1{
  font-family : alte_haas_grotesk;
  font-size : 12px;
  stroke : white;
  fill : black;
  stroke-width: 0.2;
  cursor : help;
}

.svg_node_label_2{
  font-family : alte_haas_grotesk;
  font-size : 12px;
  stroke : black;
  fill : wheat;
  stroke-width: 0.35;
  cursor : help;
}

.svg_node_label_3{
  font-family : alte_haas_grotesk;
  font-size : 10px;
  stroke : black;
  fill : wheat;
  stroke-width: 0.25;
  cursor : help;
}

.svg_node_label_4{
  font-family : alte_haas_grotesk;
  font-size : 8px;
  stroke : black;
  fill : wheat;
  stroke-width: 0.2;
  cursor : help;
}

.svg_node_label_5{
  font-family : alte_haas_grotesk;
  font-size : 6px;
  stroke : black;
  fill : wheat;
  stroke-width: 0.16;
  cursor : help;
}

.svg_node_label_map_1{
  font-family : alte_haas_grotesk;
  font-size : 12px;
  stroke : rgb(43, 2, 2);
  fill : wheat;
  stroke-width: 0.2;
}

.svg_node_label_map_2{
  font-family : alte_haas_grotesk;
  font-size : 8px;
  stroke : #395e65;
  fill : rgb(24, 16, 1);
  stroke-width: 0.35;
}

.svg_node_label_map_3{
  font-family : alte_haas_grotesk;
  font-size : 6.5px;
  stroke : #395e65;
  fill : rgb(27, 18, 1);
  stroke-width: 0.25;
}

.svg_node_label_map_4{
  font-family : alte_haas_grotesk;
  font-size : 6px;
  stroke : #395e65;
  fill : rgb(24, 16, 1);
  stroke-width: 0.15;
}

.svg_node_label_map_5{
  font-family : Helvetica;
  font-size : 6px;
  stroke : #395e65;
  fill : rgb(31, 20, 2);
  stroke-width: 0.15;
}

.domain {
  font-size: xx-large ;
  stroke-width: 2.5;
  fill : lightgreen;
  cursor :help;
}

.item {
stroke-width: .5;
fill : lightgrey;
cursor :help;
cursor :help;
}

.test {
stroke-width: .4;
fill : lightgrey;
cursor :help;
}

.check {
stroke-width: .3;
fill : lightgrey;
cursor :help;
}

.positive{
  fill : rgba(144, 238, 144, 0.8);
}
.negative{
  fill : rgba(250, 2, 2, 0.8);
}

.svg_message_span_bg{
  cursor : pointer;
  fill: white;
  stroke-width: 0;
}

.svg_message_span_bg.negative{
  stroke : red;
  stroke-width: 0.8;
}

.concept {
  border-width : 0.2px;
  border-color : black;
  cursor : url("https://altai-ego.com:3050/images/eye.svg") 8 8, auto;
}

.concept.negative{
  border-width : 2px;
  border-color : red;
}

.svg_dom_message.current_target{
  fill: wheat;  
  color: black;
  border-color: wheat;
}

text.current_target{

  stroke-width: 0.35;
}


.concept.current_target {
  border-width: 2px;
  font-size : 4.8px;
  stroke-width : 0.5;
}

  .svg_message_span{
  font-family : courier;
  box-sizing: content-box; /* définir la taille du fond en fonction du contenu du texte */
  padding: 0;

}

.svg_domain_nick_name{
  fill : #395e65;
  stroke : #efe066; 
  stroke-width: 0.6px;
  border-radius: 8px;
  font-size : 9px;
  text-align: center;
}

.svg_domain_nick_name_map{
  font-size: 40em;;
  fill : wheat;
  stroke : #151201; 
  stroke-width: 0.6px;
  border-radius: 9px;
  font-size : 25px;
  text-align: center;
}

.graph-background {
    fill : #395e65;
  }
  
circle.passed {
    fill : rgb(132, 254, 132);
    stroke: rgb(2, 33, 2);
  }

.link {
    stroke : #fff066;
    fill: #345059;
    stroke-width: 0.12;
  }
    
circle.domain  circle.item circle.test circle.check{
    stroke : #fff066;
    stroke-width: .2;
    fill : #395e65;
}

text {
    fill : #fff066;
    font-style: italic;
    font-size: xx-large ;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    stroke : black;
    stroke-width: 0.25;
}

.bg-ticks-frise {
      background-color : #395e65;
}

.tooltip {
    position: absolute;
    overflow: hidden;
    background-color : #fff066;
    pointer-events : all;
    border: 1px solid #0c0000;
    padding: 5px;
    border-radius: 3px;
    opacity: 0;
    font-size :small;
    font-family : Georgia, 'Times New Roman', Times, serif;
    transition: opacity 0.2s;
    max-width: 950px; /* Limite la largeur */
    word-wrap: break-word; /* Permet le retour à la ligne */
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);
    text-align: left;
    align-items: center;
    border-radius: 25px;
    z-index: 10;  /* 🔥 force à être au-dessus du SVG */
  }

  .tooltip_info {
    font-size :smaller;
    color: #395e65;
    background-color : #f6efb0;

    -webkit-text-stroke: 0.1px black; /* Épaisseur et couleur du contour */
  }

  .tooltip_header {
    color : #395e65;
    stroke-width: 0.2;
    -webkit-text-stroke: 0.1px black; /* Épaisseur et couleur du contour */
  }

.root {
    stroke-width: 10;
}

.domain_map {
  font-size: xx-large ;
  stroke: darkgreen;
}

.item_map {
stroke : darkgreen;
}

.test_map {
stroke : darkgreen;
}

.check_map {
stroke : darkgreen;
}

.frise {
  display : flex;
  width : 210% ;
  height : 200px;
  fill : wheat;
}
.frise-line-bg {
  stroke : white;
  fill : rgb(236, 231, 231);
}

.frise-line-bg.pointed {
  stroke : white;
  fill : gold;
}

.cat-0 {
  stroke : rgb(119, 0, 255) ;
  stroke-width : 1.8 ;
}

.cat-1 {
  stroke : rgb(17, 0, 255) ;
  stroke-width : 1.8 ;
}

.cat-2 {
  stroke : rgb(170, 0, 255) ;
  stroke-width : 1.8 ;
}

.cat-3 {
  stroke : rgb(0, 102, 255) ;
  stroke-width : 1.8 ;
}

.cat-4 {
  stroke : rgb(221, 0, 255) ;
  stroke-width : 1.8 ;
}

.cat-5 {
  stroke : rgb(0, 145, 255) ;
  stroke-width : 1.8 ;
}

.cat-6 {
  stroke : rgb(234, 255, 0) ;
  stroke-width : 1.8 ;
}

.frise-date {
  stroke-width : 0.5;
  font-size : xx-small;
  stroke : black;
  fill : black;
}

.frise-date_bg {
  cursor : pointer;
  stroke : white;
  y : -47;
  opacity : 1;
  align-self: center;
  height : 12px;
  fill : yellow;
}

.semantic-graph-display {
  display : flex;
  flex-direction : column;
  height : 100%;
  flex : 1 3;
}
.maxNbConceptsSelection {
  flex: 1 1;
  padding: 2px;
  border: 1px solid #aaa;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  font-size: 8px;
}

.maxNbConceptsSelection.selected {
  background: #fff066;
  border: 2px solid #2878d0;
  color: #395e65;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/components/graph/Graph.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,uDAAuD;EACvD,wCAAwC;EACxC,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,uCAAuC;AACzC;;;AAGA;EACE,cAAc;EACd,yBAAyB;EACzB,uCAAuC;EACvC,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,UAAU;EACV,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,UAAU;EACV,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;EACE;IACE,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,mEAAmE;IACnE,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;EAC3B;;AAEF;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;AACd;;AAEA;AACA,gBAAgB;AAChB,gBAAgB;AAChB,YAAY;AACZ,YAAY;AACZ;;AAEA;AACA,gBAAgB;AAChB,gBAAgB;AAChB,YAAY;AACZ;;AAEA;AACA,gBAAgB;AAChB,gBAAgB;AAChB,YAAY;AACZ;;AAEA;EACE,+BAA+B;AACjC;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,mEAAmE;AACrE;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;AACpB;;;AAGA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;EAEE;EACA,qBAAqB;EACrB,uBAAuB,EAAE,8DAA8D;EACvF,UAAU;;AAEZ;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EAGnB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EAGnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;IACI,cAAc;EAChB;;AAEF;IACI,yBAAyB;IACzB,qBAAqB;EACvB;;AAEF;IACI,gBAAgB;IAChB,aAAa;IACb,kBAAkB;EACpB;;AAEF;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,oBAAoB;IACpB,gDAAgD;IAChD,cAAc;IACd,kBAAkB;AACtB;;AAEA;MACM,0BAA0B;AAChC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,oBAAoB;IACpB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,sDAAsD;IACtD,wBAAwB;IACxB,gBAAgB,EAAE,sBAAsB;IACxC,qBAAqB,EAAE,gCAAgC;IACvD,0CAA0C;IAC1C,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW,GAAG,qCAAqC;EACrD;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,0BAA0B;;IAE1B,gCAAgC,EAAE,oCAAoC;EACxE;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gCAAgC,EAAE,oCAAoC;EACxE;;AAEF;IACI,gBAAgB;AACpB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;AACA,kBAAkB;AAClB;;AAEA;AACA,kBAAkB;AAClB;;AAEA;AACA,kBAAkB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,YAAY;AACd;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,UAAU;AACZ;AACA;EACE,SAAO;EACP,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB","sourcesContent":[".svg_viewbox {\r\n  float : left;\r\n  width: 150%;\r\n  height : 125%;\r\n  padding: 2x;\r\n  border-radius: 10px;\r\n  stroke : #395e65;\r\n}\r\n\r\n.svg_viewbox_fullscreen {\r\n  padding: 2x;\r\n  stroke : #395e65;\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 1000;\r\n}\r\n.qual_precision {\r\n  font-family : Helvetica;\r\n  accent-color : #becdbe; \r\n  font-size : small;\r\n  color : #becdbe;\r\n  stroke-width : 50px;\r\n} \r\n\r\n.range_input{\r\n  cursor : crosshair;\r\n  appearance : false;\r\n  height : 4px;\r\n}\r\n\r\n.depthlist_option {\r\n  /* flex: 0 20 40px; /* Ajuster la largeur des options */\r\n  transition: transform 0.3s, opacity 0.3s;\r\n  height : 19px;\r\n  border-radius: 2px;\r\n  padding : 3px;\r\n  min-width : 100px;\r\n  text-align: center;\r\n  border: 8px solid #395e65;\r\n  background-color: #becdbe;\r\n  cursor: pointer;\r\n  transform : scaley(0.7);\r\n  margin : 5px;\r\n  font-size: x-small;\r\n  box-shadow: 0 0 10px #395e65;\r\n  transition: box-shadow 0.5s ease-in-out;\r\n}\r\n\r\n\r\n.depthlist_option.active {\r\n  color: #395e65;\r\n  background-color: #fff066;\r\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.8);\r\n  z-index: 1;\r\n}\r\n\r\n.createConvForm{\r\n  cursor : pointer;\r\n  display : flex;  \r\n  flex-direction: column;\r\n  gap : 1rem;\r\n  font-family : Helvetica;\r\n  stroke : #010506;\r\n  fill : #395e65; \r\n  font-size : 4.5px;\r\n  stroke-width : 0.24;\r\n  padding: 5px;\r\n  margin : 5px;\r\n  z-index : 20;\r\n}\r\n\r\n.correctionForm{\r\n  cursor : pointer;\r\n  display : flex;  \r\n  flex-direction: column;\r\n  gap : 1rem;\r\n  font-family : Helvetica;\r\n  stroke : #010506;\r\n  fill : #395e65; \r\n  font-size : 10px;\r\n  stroke-width : 0.24;\r\n  padding: 5px;\r\n  margin : 5px;\r\n  z-index : 10;\r\n}\r\n  .svg_dom_message{\r\n    cursor : pointer;\r\n    font-family : Helvetica;\r\n    stroke : #010506;\r\n    fill : #395e65; \r\n    font-size : 4.5px;\r\n    stroke-width : 0.24;\r\n  }\r\n\r\n  .svg_dom_message.concept{\r\n    cursor : url(\"https://altai-ego.com:3050/images/eye.svg\") 8 8, auto;\r\n    font-family : Helvetica;\r\n    stroke : #010506;\r\n    fill : #395e65; \r\n    font-size : 4.5px;\r\n    stroke-width : 0.24;\r\n    border: 1px solid #010506;\r\n  }\r\n\r\n.tab_svg_dom_message{\r\n  font-family : Helvetica;\r\n  stroke : #010506;\r\n  fill : #395e65; \r\n  font-size : 4.5px;\r\n  stroke-width : 0.6;\r\n  font-weight: bold;\r\n  text-anchor : middle;\r\n}\r\n\r\n.svg_node_label_1{\r\n  font-family : alte_haas_grotesk;\r\n  font-size : 12px;\r\n  stroke : white;\r\n  fill : black;\r\n  stroke-width: 0.2;\r\n  cursor : help;\r\n}\r\n\r\n.svg_node_label_2{\r\n  font-family : alte_haas_grotesk;\r\n  font-size : 12px;\r\n  stroke : black;\r\n  fill : wheat;\r\n  stroke-width: 0.35;\r\n  cursor : help;\r\n}\r\n\r\n.svg_node_label_3{\r\n  font-family : alte_haas_grotesk;\r\n  font-size : 10px;\r\n  stroke : black;\r\n  fill : wheat;\r\n  stroke-width: 0.25;\r\n  cursor : help;\r\n}\r\n\r\n.svg_node_label_4{\r\n  font-family : alte_haas_grotesk;\r\n  font-size : 8px;\r\n  stroke : black;\r\n  fill : wheat;\r\n  stroke-width: 0.2;\r\n  cursor : help;\r\n}\r\n\r\n.svg_node_label_5{\r\n  font-family : alte_haas_grotesk;\r\n  font-size : 6px;\r\n  stroke : black;\r\n  fill : wheat;\r\n  stroke-width: 0.16;\r\n  cursor : help;\r\n}\r\n\r\n.svg_node_label_map_1{\r\n  font-family : alte_haas_grotesk;\r\n  font-size : 12px;\r\n  stroke : rgb(43, 2, 2);\r\n  fill : wheat;\r\n  stroke-width: 0.2;\r\n}\r\n\r\n.svg_node_label_map_2{\r\n  font-family : alte_haas_grotesk;\r\n  font-size : 8px;\r\n  stroke : #395e65;\r\n  fill : rgb(24, 16, 1);\r\n  stroke-width: 0.35;\r\n}\r\n\r\n.svg_node_label_map_3{\r\n  font-family : alte_haas_grotesk;\r\n  font-size : 6.5px;\r\n  stroke : #395e65;\r\n  fill : rgb(27, 18, 1);\r\n  stroke-width: 0.25;\r\n}\r\n\r\n.svg_node_label_map_4{\r\n  font-family : alte_haas_grotesk;\r\n  font-size : 6px;\r\n  stroke : #395e65;\r\n  fill : rgb(24, 16, 1);\r\n  stroke-width: 0.15;\r\n}\r\n\r\n.svg_node_label_map_5{\r\n  font-family : Helvetica;\r\n  font-size : 6px;\r\n  stroke : #395e65;\r\n  fill : rgb(31, 20, 2);\r\n  stroke-width: 0.15;\r\n}\r\n\r\n.domain {\r\n  font-size: xx-large ;\r\n  stroke-width: 2.5;\r\n  fill : lightgreen;\r\n  cursor :help;\r\n}\r\n\r\n.item {\r\nstroke-width: .5;\r\nfill : lightgrey;\r\ncursor :help;\r\ncursor :help;\r\n}\r\n\r\n.test {\r\nstroke-width: .4;\r\nfill : lightgrey;\r\ncursor :help;\r\n}\r\n\r\n.check {\r\nstroke-width: .3;\r\nfill : lightgrey;\r\ncursor :help;\r\n}\r\n\r\n.positive{\r\n  fill : rgba(144, 238, 144, 0.8);\r\n}\r\n.negative{\r\n  fill : rgba(250, 2, 2, 0.8);\r\n}\r\n\r\n.svg_message_span_bg{\r\n  cursor : pointer;\r\n  fill: white;\r\n  stroke-width: 0;\r\n}\r\n\r\n.svg_message_span_bg.negative{\r\n  stroke : red;\r\n  stroke-width: 0.8;\r\n}\r\n\r\n.concept {\r\n  border-width : 0.2px;\r\n  border-color : black;\r\n  cursor : url(\"https://altai-ego.com:3050/images/eye.svg\") 8 8, auto;\r\n}\r\n\r\n.concept.negative{\r\n  border-width : 2px;\r\n  border-color : red;\r\n}\r\n\r\n.svg_dom_message.current_target{\r\n  fill: wheat;  \r\n  color: black;\r\n  border-color: wheat;\r\n}\r\n\r\ntext.current_target{\r\n\r\n  stroke-width: 0.35;\r\n}\r\n\r\n\r\n.concept.current_target {\r\n  border-width: 2px;\r\n  font-size : 4.8px;\r\n  stroke-width : 0.5;\r\n}\r\n\r\n  .svg_message_span{\r\n  font-family : courier;\r\n  box-sizing: content-box; /* définir la taille du fond en fonction du contenu du texte */\r\n  padding: 0;\r\n\r\n}\r\n\r\n.svg_domain_nick_name{\r\n  fill : #395e65;\r\n  stroke : #efe066; \r\n  stroke-width: 0.6px;;\r\n  -moz-border-radius: 8px;\r\n  -webkit-border-radius: 8px;\r\n  border-radius: 8px;\r\n  font-size : 9px;\r\n  text-align: center;\r\n}\r\n\r\n.svg_domain_nick_name_map{\r\n  font-size: 40em;;\r\n  fill : wheat;\r\n  stroke : #151201; \r\n  stroke-width: 0.6px;;\r\n  -moz-border-radius: 9px;\r\n  -webkit-border-radius: 9px;\r\n  border-radius: 9px;\r\n  font-size : 25px;\r\n  text-align: center;\r\n}\r\n\r\n.graph-background {\r\n    fill : #395e65;\r\n  }\r\n  \r\ncircle.passed {\r\n    fill : rgb(132, 254, 132);\r\n    stroke: rgb(2, 33, 2);\r\n  }\r\n\r\n.link {\r\n    stroke : #fff066;\r\n    fill: #345059;\r\n    stroke-width: 0.12;\r\n  }\r\n    \r\ncircle.domain  circle.item circle.test circle.check{\r\n    stroke : #fff066;\r\n    stroke-width: .2;\r\n    fill : #395e65;\r\n}\r\n\r\ntext {\r\n    fill : #fff066;\r\n    font-style: italic;\r\n    font-size: xx-large ;\r\n    font-family: Verdana, Geneva, Tahoma, sans-serif;\r\n    stroke : black;\r\n    stroke-width: 0.25;\r\n}\r\n\r\n.bg-ticks-frise {\r\n      background-color : #395e65;\r\n}\r\n\r\n.tooltip {\r\n    position: absolute;\r\n    overflow: hidden;\r\n    background-color : #fff066;\r\n    pointer-events : all;\r\n    border: 1px solid #0c0000;\r\n    padding: 5px;\r\n    border-radius: 3px;\r\n    opacity: 0;\r\n    font-size :small;\r\n    font-family : Georgia, 'Times New Roman', Times, serif;\r\n    transition: opacity 0.2s;\r\n    max-width: 950px; /* Limite la largeur */\r\n    word-wrap: break-word; /* Permet le retour à la ligne */\r\n    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);\r\n    text-align: left;\r\n    align-items: center;\r\n    border-radius: 25px;\r\n    z-index: 10;  /* 🔥 force à être au-dessus du SVG */\r\n  }\r\n\r\n  .tooltip_info {\r\n    font-size :smaller;\r\n    color: #395e65;\r\n    background-color : #f6efb0;\r\n\r\n    -webkit-text-stroke: 0.1px black; /* Épaisseur et couleur du contour */\r\n  }\r\n\r\n  .tooltip_header {\r\n    color : #395e65;\r\n    stroke-width: 0.2;\r\n    -webkit-text-stroke: 0.1px black; /* Épaisseur et couleur du contour */\r\n  }\r\n\r\n.root {\r\n    stroke-width: 10;\r\n}\r\n\r\n.domain_map {\r\n  font-size: xx-large ;\r\n  stroke: darkgreen;\r\n}\r\n\r\n.item_map {\r\nstroke : darkgreen;\r\n}\r\n\r\n.test_map {\r\nstroke : darkgreen;\r\n}\r\n\r\n.check_map {\r\nstroke : darkgreen;\r\n}\r\n\r\n.frise {\r\n  display : flex;\r\n  width : 210% ;\r\n  height : 200px;\r\n  fill : wheat;\r\n}\r\n.frise-line-bg {\r\n  stroke : white;\r\n  fill : rgb(236, 231, 231);\r\n}\r\n\r\n.frise-line-bg.pointed {\r\n  stroke : white;\r\n  fill : gold;\r\n}\r\n\r\n.cat-0 {\r\n  stroke : rgb(119, 0, 255) ;\r\n  stroke-width : 1.8 ;\r\n}\r\n\r\n.cat-1 {\r\n  stroke : rgb(17, 0, 255) ;\r\n  stroke-width : 1.8 ;\r\n}\r\n\r\n.cat-2 {\r\n  stroke : rgb(170, 0, 255) ;\r\n  stroke-width : 1.8 ;\r\n}\r\n\r\n.cat-3 {\r\n  stroke : rgb(0, 102, 255) ;\r\n  stroke-width : 1.8 ;\r\n}\r\n\r\n.cat-4 {\r\n  stroke : rgb(221, 0, 255) ;\r\n  stroke-width : 1.8 ;\r\n}\r\n\r\n.cat-5 {\r\n  stroke : rgb(0, 145, 255) ;\r\n  stroke-width : 1.8 ;\r\n}\r\n\r\n.cat-6 {\r\n  stroke : rgb(234, 255, 0) ;\r\n  stroke-width : 1.8 ;\r\n}\r\n\r\n.frise-date {\r\n  stroke-width : 0.5;\r\n  font-size : xx-small;\r\n  stroke : black;\r\n  fill : black;\r\n}\r\n\r\n.frise-date_bg {\r\n  cursor : pointer;\r\n  stroke : white;\r\n  y : -47;\r\n  opacity : 1;\r\n  align-self: center;\r\n  height : 12px;\r\n  fill : yellow;\r\n}\r\n\r\n.semantic-graph-display {\r\n  display : flex;\r\n  flex-direction : column;\r\n  height : 100%;\r\n  flex : 1 3;\r\n}\r\n.maxNbConceptsSelection {\r\n  flex: 1;\r\n  padding: 2px;\r\n  border: 1px solid #aaa;\r\n  border-radius: 4px;\r\n  background: transparent;\r\n  cursor: pointer;\r\n  font-size: 8px;\r\n}\r\n\r\n.maxNbConceptsSelection.selected {\r\n  background: #fff066;\r\n  border: 2px solid #2878d0;\r\n  color: #395e65;\r\n  font-weight: bold;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
